import styled, { css } from 'styled-components';
import { normalize, withModifiers } from 'utils/styles';
import { color, media } from 'styles/settings';
import { ReactComponent as Cursor } from 'styles/icons/cursor.svg';
import { ReactComponent as Move } from 'styles/icons/move.svg';
import { ReactComponent as Note } from 'styles/icons/note.svg';
import { ReactComponent as Text } from 'styles/icons/text.svg';
import { ReactComponent as Upload } from 'styles/icons/upload.svg';
import { ReactComponent as RisSearch } from 'styles/icons/rissearch.svg';
import { ReactComponent as Paint } from 'styles/icons/draw.svg';
import { ReactComponent as Questionnaire } from 'styles/icons/questionnaire.svg';
import { ReactComponent as QuestionnaireForm } from 'styles/icons/questionnaire-form.svg';
import { ReactComponent as Protocol } from 'styles/icons/protocol-icon.svg';
import { ReactComponent as Surface } from 'styles/icons/surface.svg';
import { ReactComponent as Background } from 'styles/icons/background.svg';
import { ReactComponent as Link } from 'styles/icons/link2.svg';

const iconCss = css`
  align-items: center;
  color: ${color.brand.black};
  cursor: pointer;
  display: flex;
  margin-bottom: ${normalize('22px')};
  width: ${normalize('24px')};
  height: ${normalize('24px')};

  :hover {
    color: ${color.brand.gold};
  }

  :active {
    color: ${color.brand.black};
  }

  ${withModifiers('$isSelected')`
    color: ${color.brand.gold};
  `}

  ${withModifiers('$isDraggable')`
    color: ${color.brand.gold};
  `}
  
  ${withModifiers('disabled')`
    cursor: not-allowed;
    color: ${color.neutral.grayPale};
    :hover {
      color: ${color.neutral.grayPale};
    }

    :active {
      color: ${color.neutral.grayPale};
    }
  `}
`;

export const Container = styled.div`
  background-color: ${color.neutral.white};
  bottom: ${normalize('20px')};
  display: flex;
  flex-direction: column;
  left: ${normalize('20px')};
  padding: 0 ${normalize('18px')};
  padding-top: ${normalize('22px')};
  position: fixed;
  z-index: 2;
  ${media.mediaQueries.mobile`
    display:none;
  `}
`;

export const Icon = styled.img`
  ${iconCss};
`;

export const CursorIcon = styled(Cursor)`
  ${iconCss}
  ${withModifiers('isDraggable')`
    color: ${color.brand.gold};
  `}
`;

export const TextIcon = styled(Text)`
  ${iconCss}
`;

export const MoveIcon = styled(Move)`
  ${iconCss}
`;

export const NoteIcon = styled(Note)`
  ${iconCss}
`;

export const UploadIcon = styled(Upload)`
  ${iconCss};
`;

export const RisSearchIcon = styled(RisSearch)`
  ${iconCss};
`;

export const QuestionnaireIcon = styled(Questionnaire)`
  ${iconCss}
`;

export const ProtocolIcon = styled(Protocol)`
  ${iconCss};
`;

export const SurfaceIcon = styled(Surface)`
  ${iconCss};
`;

export const BackgroundIcon = styled(Background)`
  ${iconCss};
`;

export const PaintIcon = styled(Paint)`
  ${iconCss};
`;

export const LinkIcon = styled(Link)`
  ${iconCss};
`;

export const QuestionaireFormIcon = styled(QuestionnaireForm)`
  ${iconCss}
`;

export const Separator = styled.div`
  width: 120%;
  transform: translateX(-7.5%);
  height: 1px;
  background-color: #d5d5d5;
  margin: 0 auto 23px auto;
`;
